export default `
clip-path: circle(50% at 50% 50%);
`
